var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeingIsBelieving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1041,
    height: 756,
    viewBox: "78.5 75.5 864 582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_19246",
    filterUnits: "objectBoundingBox",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "200%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    dx: 20,
    dy: 23,
    result: "off"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "off",
    stdDeviation: "25 49.5",
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "blur",
    operator: "in",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadow"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48882",
    "data-name": "Group 48882",
    transform: "translate(-13.5 -1003.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 13.5, 1003.5)",
    filter: "url(#Rectangle_19246)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19246-2",
    "data-name": "Rectangle 19246",
    width: 744,
    height: 459,
    rx: 30,
    opacity: 0,
    transform: "translate(128.5 125.5)",
    fill: "#fbfbfb"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.5s",
    begin: "0s",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Alumni_Directory",
    "data-name": "Alumni Directory",
    transform: "translate(192 1172)",
    fill: "#3db6fb",
    fontSize: 27,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 25
  }, "Alumni Directory")), /*#__PURE__*/React.createElement("text", {
    id: "Pod_Alumni",
    "data-name": "Pod Alumni",
    transform: "translate(542 1172)",
    fill: "#3db6fb",
    fontSize: 27,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 25
  }, "Pod Alumni")), /*#__PURE__*/React.createElement("text", {
    id: "Boring_directory_providing_minimal_value",
    "data-name": "Boring directory providing minimal value",
    transform: "translate(192 1448)",
    fill: "#3eb6fb",
    fontSize: 27,
    fontFamily: "ProximaNova-Medium, Proxima Nova",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Boring directory"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 53
  }, "providing minimal"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 85
  }, "value")), /*#__PURE__*/React.createElement("text", {
    id: "Interactive_experience_showcasing_the_true_power_of_the_network",
    "data-name": "Interactive experience showcasing the true power of the network",
    transform: "translate(544 1448)",
    fill: "#3eb6fb",
    fontSize: 27,
    fontFamily: "ProximaNova-Medium, Proxima Nova",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Interactive experience"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 53
  }, "showcasing the true"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 85
  }, "power of the network")), /*#__PURE__*/React.createElement("text", {
    id: "VS",
    transform: "translate(455 1350)",
    fill: "#3db6fb",
    fontSize: 27,
    fontFamily: "ProximaNova-Bold, Proxima Nova",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VS")), /*#__PURE__*/React.createElement("g", {
    id: "Group_48878",
    "data-name": "Group 48878",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_31",
    "data-name": "Layer 31",
    transform: "translate(208.934 1248.94)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_52487",
    "data-name": "Path 52487",
    d: "M157.355,2.5H20.093A17.553,17.553,0,0,0,2.54,20.053v137.38a17.553,17.553,0,0,0,17.553,17.553H157.355a17.553,17.553,0,0,0,17.553-17.553V20.17A17.553,17.553,0,0,0,157.356,2.5ZM57.041,166.326H20.093a8.776,8.776,0,0,1-8.776-8.776V142.337H57.041Zm0-32.765H11.2V109.572H57.041Zm0-32.765H11.2V76.807H57.041Zm0-32.765H11.2V44.042H57.041Zm54.589,98.3H65.818V142.337h45.813Zm0-32.765H65.818V109.572h45.813Zm0-32.765H65.818V76.807h45.813Zm0-32.765H65.818V44.042h45.813Zm54.618,89.4a8.776,8.776,0,0,1-8.776,8.776H120.407V142.337h45.842Zm0-23.872H120.407V109.572h45.842Zm0-32.765H120.407V76.807h45.842Zm0-32.765H120.407V44.042h45.842Z",
    transform: "translate(-2.54 -2.5)",
    fill: "#09a9e8"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 0; 2 1; 0 0; -2 -1; 0 0",
    keyTimes: "0; .25; .5; .75; 1",
    dur: "7s",
    begin: "1s",
    repeatCount: "indefinite",
    additive: "sum"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0; -1.2; 0; 1.2; 0",
    keyTimes: "0; .25; .5; .75; 1",
    dur: "12s",
    begin: "1s",
    repeatCount: "indefinite",
    additive: "sum"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48877",
    "data-name": "Group 48877",
    transform: "translate(193 1233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5148",
    "data-name": "Ellipse 5148",
    transform: "translate(0)",
    fill: "none",
    stroke: "#454f63",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 102,
    r: 99,
    fill: "none",
    stroke: "#454f63",
    strokeWidth: 6,
    strokeDasharray: 640,
    strokeDashoffset: 640
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 640,
    to: 0,
    dur: "1s",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 141,
    y2: 141,
    transform: "translate(31.5 31.5)",
    stroke: "#454f63",
    strokeWidth: 6,
    strokeDasharray: 200,
    strokeDashoffset: 200
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 200,
    to: 0,
    dur: "0.6s",
    begin: "1s",
    fill: "freeze"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48876",
    "data-name": "Group 48876",
    transform: "translate(-30 -42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Screenshot_2025-07-16_at_4.52.01_PM",
    "data-name": "Screenshot 2025-07-16 at 4.52.01\\u202FPM",
    width: 220,
    height: 204,
    rx: 15,
    transform: "translate(574 1267)",
    fill: "url(#pattern)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.179 1317.781)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.306 71.064)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.306 -71.064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.306,3.375C18.37,3.375,7.875,13.122,7.875,25.13c0,16.922,23.431,45.934,23.431,45.934S54.736,42.052,54.736,25.13C54.736,13.122,44.241,3.375,31.306,3.375Zm0,31.062a7.631,7.631,0,1,1,7.631-7.631A7.632,7.632,0,0,1,31.306,34.437Z",
    fill: "#09a9e8"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "1;1.06;1",
    keyTimes: "0;0.5;1",
    dur: "1.8s",
    begin: "0s",
    repeatCount: "indefinite",
    additive: "sum",
    calcMode: "spline",
    keySplines: ".42 0 .58 1; .42 0 .58 1"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(721.181 1243.625)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.306 71.064)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.306 -71.064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.306,3.375C18.37,3.375,7.875,13.122,7.875,25.13c0,16.922,23.431,45.934,23.431,45.934S54.736,42.052,54.736,25.13C54.736,13.122,44.241,3.375,31.306,3.375Zm0,31.062a7.631,7.631,0,1,1,7.631-7.631A7.632,7.632,0,0,1,31.306,34.437Z",
    fill: "#09a9e8"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "1;1.06;1",
    keyTimes: "0;0.5;1",
    dur: "1.8s",
    begin: "0.5s",
    repeatCount: "indefinite",
    additive: "sum",
    calcMode: "spline",
    keySplines: ".42 0 .58 1; .42 0 .58 1"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(707.612 1379.436)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.306 71.064)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.306 -71.064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.306,3.375C18.37,3.375,7.875,13.122,7.875,25.13c0,16.922,23.431,45.934,23.431,45.934S54.736,42.052,54.736,25.13C54.736,13.122,44.241,3.375,31.306,3.375Zm0,31.062a7.631,7.631,0,1,1,7.631-7.631A7.632,7.632,0,0,1,31.306,34.437Z",
    fill: "#09a9e8"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    values: "1;1.06;1",
    keyTimes: "0;0.5;1",
    dur: "1.8s",
    begin: "1s",
    repeatCount: "indefinite",
    additive: "sum",
    calcMode: "spline",
    keySplines: ".42 0 .58 1; .42 0 .58 1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48873",
    transform: "translate(818.008 1340.004)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1084.6,29a28.909,28.909,0,0,1-8.7,20.71q-.708.694-1.464,1.34-.3.257-.608.506-1.108.9-2.3,1.684a29.015,29.015,0,0,1-31.84,0q-1.194-.785-2.3-1.684-.308-.248-.608-.506-.755-.645-1.464-1.34A29,29,0,1,1,1084.6,29",
    transform: "translate(-1026.612)",
    fill: "#a7def6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.511,177.985q-1.108.9-2.3,1.684a29.015,29.015,0,0,1-31.84,0q-1.194-.785-2.3-1.684a11.3,11.3,0,0,1,6.166-8.65,10.9,10.9,0,0,1-4.074-2.7,1.583,1.583,0,0,1-.1-2.093c1.4-1.745,3.987-5.121,4.012-12.885v-4.484a12.213,12.213,0,1,1,24.426,0v4.362c0,7.851,2.609,11.253,4.013,13.007a1.582,1.582,0,0,1-.1,2.093,10.943,10.943,0,0,1-4.082,2.7,11.293,11.293,0,0,1,6.175,8.65",
    transform: "translate(-1186.292 -126.434)",
    fill: "#05aae8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "1s",
    begin: "0s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "808.008 1340.004",
    to: "818.008 1340.004",
    dur: "1s",
    begin: "0s",
    fill: "freeze",
    calcMode: "spline",
    keySplines: ".42 0 .58 1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "818.008 1340.004; 821.008 1342.004; 818.008 1340.004; 815.008 1338.004; 818.008 1340.004",
    dur: "6s",
    begin: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48874",
    transform: "translate(818.008 1267.753)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.992,29a28.909,28.909,0,0,1-8.7,20.71q-.708.694-1.464,1.34a28.96,28.96,0,0,1-37.661,0Q9.411,50.4,8.7,49.706A29,29,0,1,1,57.992,29",
    transform: "translate(0)",
    fill: "#a7def6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.264,163.219q-.708.694-1.464,1.34a28.96,28.96,0,0,1-37.661,0q-.755-.645-1.464-1.34a11.307,11.307,0,0,1,7.261-7.031l8.671-2.739v-1.431c-1.082-.637-2.059-1.369-2.861-1.919a6.53,6.53,0,0,1-2.783-4.354l-.462-2.765a2.614,2.614,0,0,1-2.617-2.618v-6.106a13.085,13.085,0,0,1,26.17,0v6.106a2.614,2.614,0,0,1-2.617,2.618l-.462,2.765a6.541,6.541,0,0,1-2.791,4.354c-.8.541-1.763,1.282-2.853,1.919v1.431l8.662,2.739a11.308,11.308,0,0,1,7.27,7.031",
    transform: "translate(-128.974 -113.513)",
    fill: "#05aae8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "1s",
    begin: "0.2s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "808.008 1267.753",
    to: "818.008 1267.753",
    dur: "1s",
    begin: "0.2s",
    fill: "freeze",
    calcMode: "spline",
    keySplines: ".42 0 .58 1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "818.008 1267.753; 820.008 1269.753; 818.008 1267.753; 816.008 1265.753; 818.008 1267.753",
    dur: "7s",
    begin: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48875",
    transform: "translate(818.008 1412.254)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.992,1053.478a28.909,28.909,0,0,1-8.7,20.71l-.1.1q-.661.641-1.362,1.241a28.96,28.96,0,0,1-37.661,0q-.7-.6-1.362-1.241l-.1-.1a29,29,0,1,1,49.29-20.71",
    transform: "translate(0 -1024.482)",
    fill: "#a7def6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.668,1206.122q-.661.641-1.362,1.241a28.961,28.961,0,0,1-37.661,0q-.7-.6-1.362-1.241a11.207,11.207,0,0,1,7.29-7.244l8.583-2.71v-1.415c-1.076-.639-2.037-1.37-2.83-1.905a6.477,6.477,0,0,1-2.76-4.308l-.458-2.738a2.593,2.593,0,0,1-1.035-4.969,26.713,26.713,0,0,1-1.743-5.913,8.528,8.528,0,0,1,.029-3.906,3.071,3.071,0,0,1,2.57-2.364l.155.01a6.153,6.153,0,0,1,3.145-2.383,16.585,16.585,0,0,1,3.807-.745c.5-.058,1.006-.116,1.512-.167a20.057,20.057,0,0,1,7.255.385,9.3,9.3,0,0,1,5.9,4.527,11.21,11.21,0,0,1,.917,6.306,24.831,24.831,0,0,1-.9,4.186,2.593,2.593,0,0,1-.878,5.032l-.458,2.738a6.476,6.476,0,0,1-2.759,4.308c-.794.535-1.754,1.266-2.83,1.905v1.415l8.582,2.71a11.206,11.206,0,0,1,7.291,7.244",
    transform: "translate(-130.48 -1156.317)",
    fill: "#05aae8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "1s",
    begin: "0.4s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    from: "808.008 1412.254",
    to: "818.008 1412.254",
    dur: "1s",
    begin: "0.4s",
    fill: "freeze",
    calcMode: "spline",
    keySplines: ".42 0 .58 1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "818.008 1412.254; 821.008 1410.254; 818.008 1412.254; 815.008 1414.254; 818.008 1412.254",
    dur: "5.5s",
    begin: "1.4s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeingIsBelieving);
export default __webpack_public_path__ + "static/media/seeing-is-believing.5bb26070967287e9a83d511bee96e2d6.svg";
export { ForwardRef as ReactComponent };